import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgZorroModule } from '../../shared/NG-Zorro-Antd/ng-zorro-antd.module';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { TiktokRoutingModule } from './tiktok-routing.module';
import { TiktokPostsComponent } from './Components/tiktok-posts/tiktok-posts.component';
import { TiktokPostDetailsComponent } from './Components/tiktok-post-details/tiktok-post-details.component';
import { TiktokService } from './Services/tiktok.service';
import { TiktokCommentsComponent } from './Components/tiktok-comments/tiktok-comments.component';



@NgModule({
  declarations: [
    TiktokPostsComponent,
    TiktokPostDetailsComponent,
    TiktokCommentsComponent,
  ],
  providers: [
    TiktokService,
  ],
  imports: [
    CommonModule,
    NgZorroModule,
    TiktokRoutingModule,
    FontAwesomeModule,
  ]
})
export class TiktokModule { }